import Collapse from "bootstrap/js/dist/collapse";
import Modal from "bootstrap/js/dist/modal";

//gallery modal
document.querySelectorAll(".gallery-item").forEach((item) => {
    item.addEventListener("click", (e) => {
        e.preventDefault();
        const fullImg = item.getAttribute("href");
        const modalImage = document.getElementById("modalImage");
        modalImage.src = fullImg;
        //carry the thumbnail's alt text across, so the modal is not an unlabelled image
        const thumb = item.querySelector("img");
        modalImage.alt = thumb ? thumb.getAttribute("alt") || "" : "";
        const modal = new Modal(document.getElementById("galleryModal"));
        modal.show();
    });
});

//close the modal on click
function closeModal() {
    const galleryModalElement = document.getElementById("galleryModal");
    if (!galleryModalElement) {
        return;
    }
    galleryModalElement.addEventListener("click", () => {
        const myModal = Modal.getInstance(galleryModalElement);
        myModal.hide();
    });
}
closeModal();

//gallery page load more
//
//The deferred tiles carry their thumbnail URL and alt text on the anchor
//(data-jsa-gallery-src / data-jsa-gallery-alt) and hold no <img>, so a caching or
//image-optimizer plugin has nothing to rewrite. The fallbacks below cover markup produced by
//the older template, which may still be sitting in a plugin's HTML cache: such an <img> has
//had its data-src consumed and re-published under a plugin-private name. (bts's technique,
//ported at fb-04 item 2.)
const GALLERY_SRC_ATTRS = [
    "data-jsa-gallery-src",
    "data-src",
    "data-wpc-qw-src",
    "data-wpc-fb",
    "data-lazy-src",
];

function galleryThumbUrl(anchor) {
    const own = anchor.getAttribute("data-jsa-gallery-src");
    if (own) {
        return own;
    }
    const img = anchor.querySelector("img");
    if (!img) {
        return null;
    }
    for (const attr of GALLERY_SRC_ATTRS) {
        const value = img.getAttribute(attr);
        if (value) {
            return value;
        }
    }
    //a real src that is not a placeholder is already usable
    const src = img.getAttribute("src");
    return src && src.indexOf("data:") !== 0 ? src : null;
}

document.querySelectorAll("#gallery-load-more").forEach((item) => {
    item.addEventListener("click", (e) => {
        e.preventDefault();

        //get the hidden gallery items. The whole column is hidden, not just the
        //anchor inside it: the grid is a Bootstrap row, so hiding the anchor alone
        //would leave the column behind as a gap in the run of tiles.
        const hiddenItems = document.querySelectorAll(".gallery-col.d-none");
        if (!hiddenItems.length) {
            return;
        }
        let revealed = 0;
        //loop through the hidden items and show them
        hiddenItems.forEach((hiddenItem) => {
            const anchor = hiddenItem.querySelector(".gallery-item");
            if (!anchor) {
                return;
            }
            const thumbUrl = galleryThumbUrl(anchor);
            if (!thumbUrl) {
                return;
            }
            //build the image if the anchor does not already carry one
            let img = anchor.querySelector("img");
            if (!img) {
                img = document.createElement("img");
                img.alt = anchor.getAttribute("data-jsa-gallery-alt") || "";
                img.width = 422;
                img.height = 422;
                anchor.appendChild(img);
            }
            //set the src attribute
            img.src = thumbUrl;
            //remove the hidden class
            hiddenItem.classList.remove("d-none");
            revealed += 1;
        });
        //only retire the button if it actually did something: a silent failure here reads as a
        //caching bug, a button that stays put reads as the bug it is
        if (revealed) {
            item.remove();
        }
    });
});

//testimonials page load more
//
//Alvarado 2026-08-27 (11.07): the design's testimonials frame shows six cards over an
//orange LOAD MORE TESTIMONIALS plate (2398:42352). Every review is already in the DOM —
//the cards past six carry .d-none from loop-templates/testimonial-card.php — so this only
//has to unhide them. No data-src swap is needed: unlike the gallery tiles these cards
//carry no photographs, just the one shared google-stars.svg every card already uses.
document.querySelectorAll("#testimonials-load-more").forEach((item) => {
    item.addEventListener("click", (e) => {
        e.preventDefault();

        document
            .querySelectorAll("#testimonials-page .masonry-item.d-none")
            .forEach((hiddenItem) => {
                hiddenItem.classList.remove("d-none");
            });
        item.remove();
    });
});

// FAQ accordion — no handler needed (phase 5.9).
//
// This used to toggle an .active class on the card so the open state could be styled. Bootstrap
// already maintains .collapsed on the button, so theme/_faq.scss drives every open-state rule off
// that instead. Dropping the click handler also fixes the states a click listener cannot see:
// keyboard activation of a collapse and any programmatic .show().

// Service areas accordion — deep linking (conversion matrix SA4)
//
// Nine of the ten areas have no landing page of their own, so the Service Areas menu points
// them at /service-areas/#area-{slug}. The anchor is the accordion trigger's own id, so the
// browser scrolls there by itself; what it cannot do is open the panel. This does, and
// re-scrolls afterwards so the row clears the header band.
//
// Opening is additive: no data-bs-parent is emitted, so panels never close each other. That is
// the source theme's behaviour too, and it matters here — arriving from the menu should not
// shut a panel the visitor opened by hand.
const serviceAreaAccordion = document.querySelector(".service-area-accordion");

function serviceAreaSlugify(text) {
    return text
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
}

function findServiceAreaTrigger(anchor) {
    const byId = document.getElementById(anchor);
    if (byId && serviceAreaAccordion.contains(byId)) {
        return byId;
    }

    // Fall back to the trigger whose label slugifies to the same thing. The menu hrefs were
    // written from the area names, so a post_name that has drifted from its title (a
    // re-created area picks up a "-2" suffix) still resolves.
    const slug = anchor.slice("area-".length);
    const triggers = serviceAreaAccordion.querySelectorAll(".service-area-toggle");
    return (
        Array.prototype.find.call(
            triggers,
            (trigger) => serviceAreaSlugify(trigger.textContent) === slug,
        ) || null
    );
}

let serviceAreaScrolledTo = null;

// The site header is sticky, so an anchor parked at scroll offset 0 sits behind it. Measure it
// rather than hard-coding a figure — it is a different height at every breakpoint. The CSS
// scroll-margin-top on .service-area-toggle covers the same ground for the browser's own jump.
function serviceAreaScrollOffset() {
    const header = document.querySelector("header");
    if (!header) {
        return 0;
    }

    const position = window.getComputedStyle(header).position;
    if (position !== "sticky" && position !== "fixed") {
        return 0;
    }

    return header.getBoundingClientRect().height;
}

function openServiceAreaFromHash(hash, smooth) {
    if (!hash || hash.indexOf("#area-") !== 0) {
        return;
    }

    const trigger = findServiceAreaTrigger(hash.slice(1));
    if (!trigger) {
        return;
    }

    const panel = document.querySelector(trigger.dataset.bsTarget);
    if (panel && !panel.classList.contains("show")) {
        Collapse.getOrCreateInstance(panel, { toggle: false }).show();
    }

    const top =
        trigger.getBoundingClientRect().top +
        window.scrollY -
        serviceAreaScrollOffset() -
        16;

    window.scrollTo({
        top: Math.max(top, 0),
        behavior: smooth ? "smooth" : "auto",
    });
    serviceAreaScrolledTo = window.scrollY;
}

if (serviceAreaAccordion) {
    openServiceAreaFromHash(window.location.hash, false);

    // This script runs in the footer, before the map and the header logo have decoded, so the
    // row it just scrolled to still moves afterwards. Correct the position once everything has
    // loaded — but only if the visitor has not scrolled away in the meantime.
    window.addEventListener("load", () => {
        if (
            serviceAreaScrolledTo !== null &&
            Math.abs(window.scrollY - serviceAreaScrolledTo) < 4
        ) {
            openServiceAreaFromHash(window.location.hash, false);
        }
    });

    window.addEventListener("hashchange", () => {
        openServiceAreaFromHash(window.location.hash, true);
    });
}

//modify the functionality of the main menu with dropdowns on desktop
document.querySelectorAll(".navbar-nav a.dropdown-toggle").forEach((item) => {
    item.addEventListener("click", (e) => {
        //stop propagation
        e.stopPropagation();

        //get the href attribute
        const href = item.getAttribute("href");
        if (href === "#") {
            return;
        }

        //find the element with the class .offcanvas-start in the element's parent tree
        const offcanvasStart = item.closest(".offcanvas-start");
        if (!offcanvasStart) {
            return;
        }

        //check if the offcanvas has the show class
        const isOffcanvasShown = offcanvasStart.classList.contains("show");
        if (isOffcanvasShown) {
            return;
        }

        //go to the href
        window.location.href = href;
    });
});

//when the mobile menu is shown, check the position
let navbarToggler = document.querySelector(".navbar-toggler");
if (navbarToggler) {
    navbarToggler.addEventListener("click", () => {
        //get the .header-inner element
        let headerInner = document.querySelector(
            "#wrapper-navbar .header-inner",
        );
        if (!headerInner) {
            return;
        }

        //get the vertical position of the button relative to the window
        let pozY = navbarToggler.getBoundingClientRect().top;

        if (!pozY) {
            return;
        }

        if (pozY < 30) {
            //add class .scrolling to the .header-inner element
            headerInner.classList.add("scrolling");
        } else {
            //remove class .scrolling from the .header-inner element
            headerInner.classList.remove("scrolling");
        }
    });
}
